module.exports = __webpack_public_path__ + "img/tmp_plan.2b1d4c0e.png";